import styled, { css, FlattenSimpleInterpolation } from "styled-components";

const { detect } = require("detect-browser");
const browser = detect();

const handleBrowserType = () => {
  switch (browser && browser.name) {
    case "chrome":
      return "#F7F8F6";
    case "ios":
      return "#F6F8F5";
    case "samsung":
      return "#F3F6F3";

    default:
      console.log("not supported");
  }
};

const PersistantContentContainerViews: {
  [key: string]: FlattenSimpleInterpolation;
} = {
  mobile: css`
    top: 66px;
    height: 308px;
    width: 100%;
    margin: 0 0 0 auto;
    overflow: auto;
    padding-bottom: 5px;

    h3 {
      font-weight: bold;
      color: #000000;
    }
    p {
      font-size: 16px;
      /* margin-top: 20px; */
      color: #000000;
    }
  `,
  tablet: css`
    height: 462px;
    min-width: 575px;
    padding: 0 50px;
    top: 80px;
    overflow: auto;

    h3 {
      margin-top: auto;
      font-size: 56px;
    }
    p {
      font-size: 24px;
    }
  `,
  tabletLandscape: css`
    position: absolute;
    top: 80px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: 53%;
    height: calc(100% - 144px);
    margin: 0 0 0 auto;
    overflow: auto;
    background-color: transparent;

    h3 {
      margin-top: auto;
      font-size: 56px;
    }
    p {
      font-size: 24px;
    }
  `,

  browser: css`
    position: absolute;
    width: 50%;
    margin: 0 0 0 auto;
    height: calc(100% - 144px);
    overflow: auto;
    top: 80px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: transparent;
    h3 {
      margin-top: auto;
      font-size: 56px;
    }
  `,
};

export const PersistantContentContainer = styled.div`
  background-color: ${() => handleBrowserType()};
  ${(props: { deviceType: string; isLandscape: boolean }) => {
    switch (props.deviceType) {
      case "mobile":
        return PersistantContentContainerViews["mobile"];
      case "tablet":
        return props.isLandscape
          ? PersistantContentContainerViews["tabletLandscape"]
          : PersistantContentContainerViews["tablet"];

      case "browser":
        return PersistantContentContainerViews["browser"];
    }
  }}
`;

export const UserMessage = styled.p`
  display: flex;
  justify-content: flex-end;
  padding-right: 15px;
`;

export const FadeOutOverlay = styled.div`
  background: linear-gradient(360deg, rgba(232, 232, 232, 0), #f2f2f2 100%);
  position: fixed;
  height: 50px;
  width: 100%;
  opacity: 0;
`;

const TranscriptBoxViews: {
  [key: string]: FlattenSimpleInterpolation;
} = {
  mobile: css`
    width: 336px;
    margin: 0 auto;
  `,
  tablet: css``,
  tabletLandscape: css`
    margin-right: 5%;
  `,

  browser: css`
    margin-right: 5%;
  `,
};

export const TranscriptBox = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  margin-top: auto;
  ${(props: { deviceType: string; isLandscape: boolean }) => {
    switch (props.deviceType) {
      case "mobile":
        return TranscriptBoxViews["mobile"];
      case "tablet":
        return props.isLandscape
          ? TranscriptBoxViews["tabletLandscape"]
          : TranscriptBoxViews["tablet"];

      case "browser":
        return TranscriptBoxViews["browser"];
    }
  }}
`;
